import OfflineNotification from './OfflineNotification'

export default OfflineNotification
